export const CREATE_CLASS_USAGE_OPERATION = 'create-class-usage';
export const MODIFY_CLASS_USAGE_OPERATION = 'modify-class-usage';
export const CREATE_RELATIONSHIP_USAGE_OPERATION = 'create-relation-usage';
export const MODIFY_RELATIONSHIP_USAGE_OPERATION = 'modify-relation-usage';
export function isCreateClassUsageOperation(operation) {
    return operation.type === CREATE_CLASS_USAGE_OPERATION;
}
export function isModifyClassUsageOperation(operation) {
    return operation.type === MODIFY_CLASS_USAGE_OPERATION;
}
export function isCreateRelationshipUsageOperation(operation) {
    return operation.type === CREATE_RELATIONSHIP_USAGE_OPERATION;
}
export function isModifyRelationshipUsageOperation(operation) {
    return operation.type === MODIFY_RELATIONSHIP_USAGE_OPERATION;
}
/**
 * @deprecated
 */
export function createClassUsage(entity) {
    return {
        type: CREATE_CLASS_USAGE_OPERATION,
        entity
    };
}
/**
 * @deprecated
 */
export function modifyClassUsage(id, entity) {
    return {
        type: MODIFY_CLASS_USAGE_OPERATION,
        id,
        entity
    };
}
/**
 * @deprecated
 */
export function createRelationshipUsage(entity) {
    return {
        type: CREATE_RELATIONSHIP_USAGE_OPERATION,
        entity
    };
}
/**
 * @deprecated
 */
export function modifyRelationshipUsage(id, entity) {
    return {
        type: MODIFY_RELATIONSHIP_USAGE_OPERATION,
        id,
        entity
    };
}
//# sourceMappingURL=operations.js.map